import { Component } from '@angular/core';

@Component({
  selector: 'app-angle-up',
  imports: [],
  template: `
    <svg
      width="24"
      height="24"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8139 9.01107C12.9124 9.0106 13.0101 9.02982 13.1011 9.0676C13.1921 9.10538 13.2747 9.16096 13.3439 9.23107L18.3439 14.2311C18.4436 14.377 18.4886 14.5534 18.471 14.7292C18.4533 14.9051 18.3741 15.069 18.2474 15.1922C18.1207 15.3153 17.9545 15.3898 17.7782 15.4024C17.6019 15.415 17.4269 15.3649 17.2839 15.2611L12.8139 10.8211L8.34391 15.2611C8.20295 15.3525 8.03539 15.3939 7.86809 15.3787C7.70078 15.3635 7.54342 15.2926 7.42123 15.1773C7.29903 15.062 7.21908 14.9091 7.19418 14.7429C7.16928 14.5768 7.20087 14.4071 7.28391 14.2611L12.2839 9.26107C12.3506 9.18551 12.432 9.12436 12.5231 9.08137C12.6142 9.03838 12.7132 9.01446 12.8139 9.01107Z"
        fill="currentColor"
      />
    </svg>
  `
})
export class AngleUpComponent {}
